export enum DrawingToolConfigType {
	ToolbarHeight = 'TOOLBAR_HEIGHT',
	Opacity = 'OPACITY',
	Language = 'LANGUAGE',
	ImageSrc = 'IMAGE_SRC',
}
